import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-ras',
  templateUrl: './confirm-delete-ras.component.html',
  styleUrls: ['./confirm-delete-ras.component.scss'],
})
export class ConfirmDeleteRasComponent implements OnInit {

  
  get title(): string {
    return this.data?.title || 'Confirmar eliminación';
  }

  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmDeleteRasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
 
  ngOnInit() {}

  close(response: boolean) {
    this.dialogRef.close(response);
  }
}
